import { createReducer } from '@reduxjs/toolkit'
import {

    dUsersClearFiltersAC,
    dUsersEditItemAC,
    dUsersSetDataAC,
    dUsersSetDetailItemAC,
    dUsersSetFiltersAC,
    dUsersDeleteItemAC,
    dUsersSetPageNumberAC,
    dUsersSetItemsForPageAC,
    dUsersSetPaginationAC
} from 'model/dashboardUsers/dUsersActionCreators'
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';
import { typePagination } from 'model/system/constants';

// Type
export type IdUsersStateDataItem = {
    dateCreated: string,
    dateUpdated?: string,
    id: string,
    name: string,
    phoneNumber: string,
    position: string,
    storeId: string,
    deleted?: boolean,
    email: string,
    pin?: string,
    testCleanPin?: any,
    store?: {
        id: string,
        name: string,
        deleted: boolean

    }
}

// Type
export type typeEditUsersStateDataItem = {

    id: string,
    name?: string,
    phoneNumber?: string,
    position?: string,
    storeId?: string,
    deleted?: boolean,
    email?: string,
    pin?: string,
    store?: {
        id: string,
        name: string,
        deleted: boolean
    }
}

export type typeUsersFilters = {
    name?: string | null,
    storeId?: string | null,
    deleted?: boolean | null,
    position?: string | null | string[]
}

export type IdUsersState = {
    pagination: typePagination,
    data: IdUsersStateDataItem[],
    detailItem: IdUsersStateDataItem | undefined
    filters: typeUsersFilters
}

// Clean filter object
export const cleanFilterObject: typeUsersFilters = {
    name: null,
    storeId: null,
    deleted: false,
}

// Init state
export const initialState: IdUsersState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailItem: undefined,
    filters: cleanFilterObject
}

// Reducer
export const DUsersReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dUsersSetDataAC, ( state, action ) => {
            state.data = action.payload.dataList
        })

        // Reducer of set pagination
        .addCase(dUsersSetPaginationAC, (state, action) => {
            state.pagination = {...state.pagination, ...action.payload.pagination}
        })

        // Reducer of set items for page pagination
        .addCase(dUsersSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })

        // Reducer of set pageNumber pagination
        .addCase(dUsersSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dUsersSetDetailItemAC, ( state, action ) => {
            state.detailItem = state.data.find(( item ) => item.id === action.payload)
        })

        // Reducer of set item in data
        .addCase(dUsersEditItemAC, ( state, action ) => {
            state.data = state.data.map(( item ) => {
                if (item.id === action.payload.id) {
                    return action.payload
                } else {
                    return item
                }
            })
        })

        // Reducer of delete item
        .addCase(dUsersDeleteItemAC, ( state, action ) => {
            state.data = state.data.filter(( item ) => item.id !== action.payload)
        })

        // Reducer of clear filtersForm
        .addCase(dUsersClearFiltersAC, ( state ) => {
            state.filters = cleanFilterObject
        })

        // Reducer of set filtersForm
        .addCase(dUsersSetFiltersAC, ( state, action ) => {
            state.filters = {...state.filters,...action.payload}
            state.pagination.pageNumber = 0
        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

        .addCase(resetReducers, (state, action) => {
            if (action.payload !== "staff") {
                state.data = initialState.data
                state.detailItem=initialState.detailItem
                state.filters = initialState.filters
                state.pagination = initialState.pagination
            }
        });
})
